import { Component } from '@angular/core';
import { NavController,  ViewController, Config, AlertController,} from 'ionic-angular';

import { UserMyRadiant as User, PermitProvider, Me } from '../../../providers';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant} from '../../../providers';
import { Camera,CameraOptions } from '@ionic-native/camera';
import { Base64 } from "@ionic-native/base64";

import { File } from '@ionic-native/file';
import { FileChooser } from '@ionic-native/file-chooser';
import { FilePath } from '@ionic-native/file-path';
import * as mapboxgl from 'mapbox-gl';
import { Geolocation } from '@ionic-native/geolocation';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { AppActivity } from '../activityApp/activity';

@Component({
  selector: 'activity-add',
  templateUrl: 'page.html'
})
export class AddActivity {
  loading : any;
  formPermit = {
    type:'',
    date:'',
    purpose:'',
  };
  parameter = {
    jarak : '0',
    img_binary:null,
    file_name:null,
    location:null,
    title:'',
    client:'',
    description:'',
    id:this.userApi.data.Employee_ID,
    code:this.userApi.data.NIK,
    name:this.userApi.data.Nama_Karyawan,
  };
  data = {
    listType:[{}],
    preview_img : './assets/img/no_img.jpg',
    style : 'mapbox://styles/mapbox/outdoors-v9',
    user:{
      lat : 0,
      lng : 0,
    },
    kantor : {
      lat:-6.240275,
      lng:106.819667
    }
  };
  filePermit:any;
  map = mapboxgl.Map;
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public activityProvider   : Me,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    public camera             : Camera,
    public file               : File, 
    private fileChooser       : FileChooser,
    private base64            : Base64,
    private filepath          : FilePath,
    private geolocation       : Geolocation,
    private androidPermissions: AndroidPermissions,
    public alertCtrl          : AlertController
    ) {
    this.config.set('backButtonText','Add Activity');
    // this.getListType();
    mapboxgl.accessToken = this.userApi.tokenMapbox;
  }

  
  ionViewWillEnter(){
    this.loading = this.helper.showLoading("Loading Map.....");
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.LOCATION).then(
      result => this.getPosition(),
      err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.LOCATION)
    );
  }
  ionViewDidEnter(){
    this.getPosition(() => {
      this.cekRadius();
      this.buildMap();
    });
  }  

  getPosition(callback?:any){
    let me = this;
    let watch = this.geolocation.watchPosition();
    this.geolocation.getCurrentPosition().then((data) => {
      this.data.user.lat = data.coords.latitude;
      this.data.user.lng = data.coords.longitude;
      callback();
    });
  }

  buildMap() {
    // console.log(this.map);
    this.map = new mapboxgl.Map({
      container: 'map',
      style: this.data.style,
      attributionControl:false,
      zoom: 10,
      center: [this.data.user.lng, this.data.user.lat]
    });
    
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.addControl(new mapboxgl.GeolocateControl({
      positionOptions: {
      enableHighAccuracy: true,
      zoom:0
      },
      trackUserLocation: true
    }));
    this.map.on('load',() => {
      new mapboxgl.Marker({
        draggable: false
        }).setLngLat([this.data.user.lng, this.data.user.lat]).addTo(this.map);
        
      var el = document.createElement('div');
      el.className = 'marker';
      el.style.backgroundImage =
      'url(https://placekitten.com/g/40/40/)';
      el.style.width = '40px';
      el.style.height = '40px';
      // new mapboxgl.Marker(
      //   {draggable:false}
      // )
      // .setLngLat([this.data.kantor.lng,this.data.kantor.lat])
      // .addTo(this.map);
      try{
        this.loading.dismiss();
      }catch(e){}
    })      
  }

  showCamera(){
    let me = this;
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      saveToPhotoAlbum:true,
      sourceType: this.camera.PictureSourceType.CAMERA,
      cameraDirection:this.camera.Direction.FRONT,
      correctOrientation : true
    }
    
    this.camera.getPicture(options).then((uri) => {
      this.setFile(uri);
      
    }, (err) => {
     // Handle error
    });
  }

  chooseFile(){
    let me = this;
    this.fileChooser.open()
      .then(uri => {
        this.setFile(uri);
      })
      .catch(e => console.log(e));
  }

  getListType(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.repositoryProvider.getListPermitType(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.listType = resp.data;
      }
    },(err) => {
      this.helper.presentSwal('','Errorr','error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  setFile(url){
    let me = this;
    this.filepath.resolveNativePath(url).then(imageData => {
      me.data.preview_img = imageData;
      this.file.resolveLocalFilesystemUrl(imageData).then(file => {
        me.parameter.file_name = file.name;
      })
      this.base64.encodeFile(imageData).then((base64File: string) => {
        me.parameter.img_binary = base64File;
      }, (err) => {
        console.log(err);
      });
    })
    .catch(err => console.log(err));
  }

  submit(){
    let me = this;
    let options = {
      desc:"Are you sure you want to add this Activity?",
      inputType:"",
      className:"swal-text-center"
    };
    this.helper.presentSwalConfirmation(options,() => {
      me.actSubmit();
    })
  }

  actSubmit(){
    this.loading = this.helper.showLoading("Processing Data...");
    this.parameter.location = JSON.stringify(this.data.user);
    this.activityProvider.add_activity(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        this.helper.presentSwal('Success','Your activity has ben inserted','success');
        this.viewCtrl.dismiss();
        this.nav.setRoot(AppActivity,{tabIndex:0});
      }
    },(err) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });
  }

  cekRadius(){
    let  lat1 = this.data.kantor.lat;
    let lon1 = this.data.kantor.lng;

    let lat2 = this.data.user.lat;;
    let lon2 = this.data.user.lng;;
    let R = 6371; // Radius of the earth in km
    let dLat = (lat2 - lat1) * Math.PI / 180;  // deg2rad below
    let dLon = (lon2 - lon1) * Math.PI / 180;
    let a = 
      0.5 - Math.cos(dLat)/2 + 
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      (1 - Math.cos(dLon))/2;
    let outJarak =  R * 2 * Math.asin(Math.sqrt(a));
    let jarak = '';
    if(outJarak >= 1){
      jarak = outJarak.toFixed(1) + ' km';
    }else{
      jarak = (parseInt(outJarak.toFixed(3)) * 1000) + ' m';
    }
    //cekk jarak 1 = 1km
    this.parameter.jarak = jarak;
  }

}



// WEBPACK FOOTER //
// ./src/pages/activity/add_activity/page.ts